import Lock from './Lock';

export default Lock;
